// app/plugins/hedging/strategy.ts

/**
 * Recommend a hedging strategy based on the overall risk score.
 * - High risk (>70): Recommend buying put options on the Nifty 50.
 * - Moderate risk (>40): Recommend using inverse ETFs.
 * - Low risk: No hedging needed.
 */
// Export the type definition
export type HedgingStrategy =
  | 'buy_puts'
  | 'inverse_etf'
  | 'collar_strategy'
  | 'beta_hedging'
  | 'pairs_trading'
  | 'delta_neutral'
  | 'none'

export const recommendStrategy = (
  riskScore: number,
  betaValue: number
): HedgingStrategy => {
  if (riskScore > 80) {
    return 'buy_puts'
  } else if (riskScore > 60) {
    return 'collar_strategy'
  } else if (riskScore > 50 && betaValue > 1.5) {
    return 'beta_hedging'
  } else if (riskScore > 40) {
    return 'inverse_etf'
  } else if (riskScore > 30) {
    return 'pairs_trading'
  } else if (riskScore > 20) {
    return 'delta_neutral'
  }
  return 'none'
}

export const getStrategyDescription = (strategy: HedgingStrategy): string => {
  const descriptions: Record<HedgingStrategy, string> = {
    buy_puts: 'Buy put options on index/stocks to protect against downside',
    inverse_etf: 'Use inverse ETFs to hedge market exposure',
    collar_strategy: 'Buy puts and sell calls to create a protected range',
    beta_hedging: 'Hedge based on portfolio beta using index futures',
    pairs_trading: 'Long-short pairs to neutralize market risk',
    delta_neutral: 'Options combination to achieve delta neutrality',
    none: 'No hedging required at current risk levels'
  }
  return descriptions[strategy]
}
